import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { inquiryStatus } from '../../utils/status';

interface Props {
  rowData: any;
  sort: boolean;
  loading: boolean;
  total: number;
  selectedRow: React.Key[];
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleChangePage: Function;
  page: number;
  setSort: React.Dispatch<React.SetStateAction<boolean>>;
}

const LogisticsCenterTable = ({
  loading,
  rowData,
  total,
  setSelectedRow,
  selectedRow,
  sort,
  handleChangePage,
  page,
  setSort
}: Props) => {
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRow(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRow,
    onChange: onSelectChange
  };

  const history = useHistory();

  const columns = [
    {
      title: '영수증 번호',
      dataIndex: 'receiptId',
      key: 'receiptId'
    },
    {
      title: '판매자 이름',
      dataIndex: 'sellerName',
      key: 'sellerName'
    },
    {
      title: '거래 물류센터명',
      dataIndex: 'warehouseName',
      key: 'warehouseName'
    },
    {
      title: '금액',
      dataIndex: 'serviceAmount',
      key: 'serviceAmount',
      render: (serviceAmount: string) => `US$ ${serviceAmount ?? 0}`
    },
    {
      title: '상태',
      dataIndex: 'serviceStatus',
      key: 'serviceStatus',
      render: (serviceStatus: string) => inquiryStatus(serviceStatus)
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          업데이트일
          {!sort ? (
            <DownOutlined
              style={{ marginLeft: '1rem' }}
              onClick={() => {
                setSort(true);
              }}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '1rem' }}
              onClick={() => setSort(false)}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt',
      key: 'updatedAt'
    }
  ];

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        loading={loading}
        columns={columns}
        dataSource={rowData}
        pagination={{
          pageSize: 10,
          total: total,
          current: page,
          onChange: (newPage) => {
            handleChangePage(newPage);
          }
        }}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              history.push(`/admin/busk/warehouse-settlement/${record.id}`);
            }
          };

        }}
      />
    </div>
  );
};

export default LogisticsCenterTable;
